import React from "react";
import Lozenge from "../accoutrements/lozenge";
import { AuthorObject } from "./Contributors";
import { Typography } from "@material-tailwind/react";
import ContentContainer from "../containers/ContentContainer";
import { ContributorType } from "@/src/types";
import Contributors from "./Contributors";
import Link from "next/link";
import { isTheSameDay } from "@/src/utils/date";

export interface CategoriesObject {
  name: string;
  uri: string;
  slug: string;
}

export interface HeaderProps {
  categories: CategoriesObject[];
  title: string;
  subTitle: string;
  author: AuthorObject;
  date: string;
  modified?: string;
  contributors: ContributorType[];
}

const Header = ({
  categories = [],
  title,
  subTitle,
  author,
  date,
  modified,
  contributors,
}: HeaderProps) => {
  const showModified = modified && !isTheSameDay(date, modified);
  return (
    <div className={"bg-slate-100"}>
      <ContentContainer>
        <div className={"mb-2 flex "}>
          <div className={"container flex flex-col mx-auto gap-y-4"}>
            <div className={"flex flex-row gap-2"}>
              {categories.map(function (category) {
                return (
                  <Link href={`${category.uri}`} key={category.uri}>
                    <Lozenge color="dark" text={category.name} />
                  </Link>
                );
              })}
            </div>
            {title && (
              <Typography variant="h1" className="font-bold">
                {title}
              </Typography>
            )}

            <p className="lg:w-[75%]">{subTitle}</p>
            <span className="font-light">
              {new Date(date).toLocaleDateString("en-AU")}
            </span>
            {showModified && modified && (
              <span className="font-light">
                Updated: {new Date(modified).toLocaleDateString("en-AU")}
              </span>
            )}
            <Contributors contributors={contributors} />
          </div>
        </div>
      </ContentContainer>
    </div>
  );
};

export default Header;
